import React from 'react';
import LogoAndAsideTogglePart from './LogoAndAsideToggle.part';
import { AsideHead } from '../../../../components/layouts/Aside/Aside';

const AsideHeadPart = () => {
	return (
		<AsideHead>
			<LogoAndAsideTogglePart />
		</AsideHead>
	);
};

export default AsideHeadPart;
